
import { ThemeProvider } from "styled-components";
import { adminTheme } from "../theme";
import styled from "styled-components";
import Navbar from "../components/admin/Navbar";
import Footer from "../components/admin/Footer";

import {
  Box,
} from "@chakra-ui/react";

const AdminLayout = ({ children }) => {
  return (
    <ThemeProvider theme={adminTheme}>
      <Box
        bg={adminTheme.background}  // Set background using the theme
        color={adminTheme.color}    // Set color using the theme
        minH="100vh"                   // Ensure the container takes full height
        display="flex"
        flexDirection="column"         // Stack items vertically
        px={0}                         // No horizontal padding
      >
        <Navbar />
        <Box pt="72px" pb="72px">
          {children}
        </Box>
        <Footer />
      </Box>
    </ThemeProvider>
  );
};

export default AdminLayout;
